import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    hasLogin: false,
    userInfo: {},
    inviteCode: uni.getStorageSync('INVITE_CODE') || ''
  },
  mutations: {
    setInviteCode(state, code) {
      state.inviteCode = code || ''
    },
    login(state, provider) {
      state.hasLogin = true
      state.userInfo = provider
      uni.setStorageSync('userInfo', provider)

      location.reload()

    },
    logout(state) {
		console.log(state)
      state.hasLogin = false
      state.userInfo = {}
      uni.removeStorageSync('userInfo')
      // location.reload()
      uni.redirectTo({
        url: '/pages/public/login'
      })
    }
  },
  actions: {

  },
  getters: {
    getUserInfo(state) {
      return state.userInfo
    }
  }
})

export default store
